module.exports = __webpack_public_path__ + "img/seat-3.d9f75924.jpg";